import utils from '@/utils'

const modules = import.meta.glob('/src/views/**/**.{tsx,vue}')

const components: { [key: string]: Component } = utils.mapping(modules)

export default {
  path: '/',
  name: 'jersey-design',
  component: components['jersey-design'],
  meta: {
    title: '球衣设计',
    activeMenu: 'jersey-design',
    showSide: true,
    auth: []
  }
}
